(function () {
  "use strict";

  var sfVSImporter = {};
  var csvData;
  var dsHHSData;
  var dsServiceLocationData;
  var dsServiceData;
  var dsFacilityData;

  /**
   * Init the Visiting Services importer.
   *
   * @memberof module:serviceImporter
   */
  sfVSImporter.init = function () {
    var $loader = $(".qld__sf_admin_vs_importer");
    var $importForm = $("#sf-vs-importer__form");
    var $importBtn = $("#sf-vs-importer__import-btn");

    var $importLogAdded = $("#sf-importer-tab--added");
    var $importLogNotFound = $("#sf-importer-tab--not-found");
    var $importLogAlreadyExists = $("#sf-importer-tab--already-exists");
    var $importLogOtherErrors = $("#sf-importer-tab--other-errors");
    var counter = ".sf-importer-tab--counter";

    $importBtn.on("click", function (e) {
      e.preventDefault();
      $importForm.valid();

      var $csvField = $("#sf-vs-importer__csv");
      var files = $csvField[0].files;

      if ($importForm.valid()) {
        $loader.addClass("loading");
        $importLogAdded.empty();
        $("#sf-importer-tab-heading--added").find(counter).html("0");
        $importLogNotFound.empty();
        $("#sf-importer-tab-heading--not-found").find(counter).html("0");
        $importLogAlreadyExists.empty();
        $("#sf-importer-tab-heading--already-exists").find(counter).html("0");
        $importLogOtherErrors.empty();
        $("#sf-importer-tab-heading--other-errors").find(counter).html("0");

        var reader = new FileReader();
        reader.onload = function (e) {
          const text = e.target.result
            .replaceAll("|", "")
            .replaceAll("\r", "")
            .trim();
          csvData = sfVSImporter.csvToArray(text);
          sfVSImporter.getDatastoreData();
        };
        reader.readAsText(files[0]);
      } else {
        console.log("Not valid");
      }
    });
  };

  /**
   * Convert CSV content into an array
   *
   * @memberof module:serviceImporter
   */
  sfVSImporter.csvToArray = function (csv) {
    const headers = csv.slice(0, csv.indexOf("\n")).split(",");
    const rows = csv.slice(csv.indexOf("\n") + 1).split("\n");

    const arr = rows.map(function (row) {
      const values = row.split(",");

      const el = headers.reduce(function (object, header, index) {
        if (
          header === "SourceDataSet_HHSMaster" ||
          header === "Clinic_StartDate" ||
          header === "Clinic_EndDate" ||
          header === "Clinic_CCCCode" ||
          header === "Clinic_Facility" ||
          header === "Clinic_Specialty"
        ) {
          object[header] = values[index];
        }
        return object;
      }, {});
      return el;
    });

    // return the array
    return arr;
  };

  /**
   * Get Service Locations, Facilities, HHS list and Services from Datastore.
   *
   * @memberof module:serviceImporter
   */
  sfVSImporter.getDatastoreData = function () {
    fetch(`${serviceFinderData.baseURL}/service-locations`)
      .then((response) => response.json())
      .then((response) => {
        dsServiceLocationData = response;

        return fetch(`${serviceFinderData.baseURL}/services`);
      })
      .then((response) => response.json())
      .then((response) => {
        dsServiceData = response;

        return fetch(`${serviceFinderData.baseURL}/facilities`);
      })
      .then((response) => response.json())
      .then((response) => {
        dsFacilityData = response;
        return fetch(`${serviceFinderData.baseURL}/hhs`);
      })
      .then((response) => response.json())
      .then((response) => {
        dsHHSData = response;
        sfVSImporter.findMatch();
      })
      .catch((err) => console.error(err));
  };

  /**
   * Find a matching service location
   *
   * @memberof module:serviceImporter
   */
  sfVSImporter.findMatch = function () {
    $("#sf-importer__log").fadeIn("slow");
    var updateList = [];

    csvData.forEach(function (row) {
      var matchingHHS;
      var matchingService;
      var matchingFacility;
      var matchingServiceLocation;

      matchingHHS = dsHHSData.filter((hhs) => {
        return hhs.abbrev === row.SourceDataSet_HHSMaster;
      });

      if (matchingHHS.length) {
        if (row.Clinic_CCCCode) {
          matchingService = dsServiceData.filter((service) => {
            return service.service_corporate_clinic_code === row.Clinic_CCCCode;
          });

          if (matchingService.length) {
            matchingService = matchingService[0];
            if (row.Clinic_Facility) {
              matchingFacility = dsFacilityData.filter((facility) => {
                return (
                  facility.facility_import_mapping_name === row.Clinic_Facility
                );
              });

              if (matchingFacility.length) {
                matchingFacility = matchingFacility[0];

                dsServiceLocationData.forEach(function (serviceLocation, i) {
                  if (
                    serviceLocation.facility_id === matchingFacility.id &&
                    serviceLocation.service_id === matchingService.id
                  ) {
                    matchingServiceLocation = i;
                  }
                });

                if (matchingServiceLocation) {
                  if (
                    dsServiceLocationData[matchingServiceLocation]
                      .facility_level === "visiting-service"
                  ) {
                    if (
                      row.Clinic_StartDate.length &&
                      row.Clinic_EndDate.length
                    ) {
                      row.Clinic_StartDate = sfVSImporter.removeTime(
                        row.Clinic_StartDate,
                      );
                      row.Clinic_EndDate = sfVSImporter.removeTime(
                        row.Clinic_EndDate,
                      );

                      if (
                        sfVSImporter.validateDate(row.Clinic_StartDate) &&
                        sfVSImporter.validateDate(row.Clinic_EndDate)
                      ) {
                        row.Clinic_StartDate = sfVSImporter.convertDateFormat(
                          row.Clinic_StartDate,
                        );
                        row.Clinic_EndDate = sfVSImporter.convertDateFormat(
                          row.Clinic_EndDate,
                        );
                        var dates = [];
                        if (row.Clinic_StartDate === row.Clinic_EndDate) {
                          dates.push(row.Clinic_StartDate);
                        } else {
                          dates = sfVSImporter.getDatesInRange(
                            row.Clinic_StartDate,
                            row.Clinic_EndDate,
                          );
                        }

                        var matchingDates = sfVSImporter.checkDates(
                          dates,
                          dsServiceLocationData[matchingServiceLocation]
                            .visiting_service_dates,
                        );

                        if (matchingDates.length) {
                          var datestring = matchingDates.join(", ");
                          if (
                            dsServiceLocationData[matchingServiceLocation]
                              .visiting_service_dates
                          ) {
                            dsServiceLocationData[
                              matchingServiceLocation
                            ].visiting_service_dates =
                              dsServiceLocationData[matchingServiceLocation]
                                .visiting_service_dates +
                              ", " +
                              datestring;
                          } else {
                            dsServiceLocationData[
                              matchingServiceLocation
                            ].visiting_service_dates = datestring;
                          }
                          updateList.push(matchingServiceLocation);
                        } else {
                          sfVSImporter.report(
                            `The date is already in the Service Location. Service Location - <strong>${dsServiceLocationData[matchingServiceLocation].name}</strong>`,
                            "Already exists",
                            "info",
                          );
                        }
                      } else {
                        sfVSImporter.report(
                          `Error - Incorrect date. Please check if the date is in the DD/MM/YYYY format and it is an actual date. - <strong>${dsServiceLocationData[matchingServiceLocation].name}</strong>`,
                          "Other errors",
                          "error",
                        );
                      }
                    } else {
                      sfVSImporter.report(
                        `Error - Dates missing. Please check if the date is entered correctly. - <strong>${dsServiceLocationData[matchingServiceLocation].name}</strong>`,
                        "Other errors",
                        "error",
                      );
                    }
                  } else {
                    sfVSImporter.report(
                      `Error - Service exists but it is not a visiting service. Service Location - <strong>${dsServiceLocationData[matchingServiceLocation].name}</strong>`,
                      "Not found",
                      "error",
                    );
                  }
                } else {
                  sfVSImporter.report(
                    `Error - Service Location not found  - <strong>${row.Clinic_CCCCode}</strong> - <strong>${row.Clinic_Facility}</strong>`,
                    "Not found",
                    "error",
                  );
                }
              } else {
                sfVSImporter.report(
                  `Error - Facility not found. Clinic_Facility - <strong>${row.Clinic_Facility}</strong>`,
                  "Not found",
                  "error",
                );
              }
            } else {
              sfVSImporter.report(
                `Error - Clinic_Facility not found.`,
                "Not found",
                "error",
              );
            }
          } else {
            sfVSImporter.report(
              `Error - Service not found. Clinic_CCCCode - <strong>${row.Clinic_CCCCode}</strong>`,
              "Not found",
              "error",
            );
          }
        } else {
          sfVSImporter.report(
            `Error - Clinic_CCCCode not found.`,
            "Not found",
            "error",
          );
        }
      }
    });

    sfVSImporter.importVisitingServiceDates(updateList);

    var $loader = $(".qld__sf_admin_vs_importer");
    $loader.removeClass("loading");
  };

  sfVSImporter.removeTime = function (dateString) {
    // Split the date string by space
    var parts = dateString.split(" ");

    // Extract only the date part (before the space)
    var datePart = parts[0];

    return datePart;
  };

  sfVSImporter.convertDateFormat = function (dateString) {
    // Extract day, month, and year from the string
    var parts = dateString.split("/");
    var day = parts[0];
    var month = parts[1];
    var year = parts[2];

    // Create the converted date string in YYYY-MM-DD format
    var convertedDateString =
      year + "-" + month.padStart(2, "0") + "-" + day.padStart(2, "0");

    return convertedDateString;
  };

  sfVSImporter.validateDate = function (dateString) {
    const dateFormat = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

    if (!dateFormat.test(dateString)) {
      return false;
    }

    var parts = dateString.split("/");
    var day = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10);
    var year = parseInt(parts[2], 10);

    const date = new Date(year, month - 1, day);

    // Check if it's an actual date
    if (
      date.getFullYear() !== year ||
      date.getMonth() + 1 !== month ||
      date.getDate() !== day
    ) {
      return false;
    }

    if (isNaN(date.getTime())) {
      return false;
    }

    return true;
  };

  /**
   * Converts date range into an array of dates
   *
   * @memberof module:serviceImporter
   */
  sfVSImporter.getDatesInRange = function (startDate, endDate) {
    const d1 = new Date(startDate);
    const d2 = new Date(endDate);
    const date = new Date(d1.getTime());
    const dates = [];

    while (date <= d2) {
      new Date(date);
      dates.push(
        date.getFullYear() +
          "-" +
          ("0" + (date.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + date.getDate()).slice(-2),
      );
      date.setDate(date.getDate() + 1);
    }

    return dates;
  };

  /**
   * Check if the dates are already saved in the Visiting service.
   * Returns the dates that are not in the Visiting service.
   *
   * @memberof module:serviceImporter
   */
  sfVSImporter.checkDates = function (dates, visitingServiceDates) {
    visitingServiceDates = visitingServiceDates.replaceAll(" ", "").split(",");

    var newDates = [];
    dates.forEach(function (date) {
      var matchingDates = [];

      matchingDates = visitingServiceDates.filter((visitingServiceDate) => {
        return date === visitingServiceDate;
      });

      if (!matchingDates.length) {
        newDates.push(date);
      }
    });

    return newDates;
  };

  /**
   * Import the Visiting service
   *
   * @memberof module:serviceImporter
   */
  sfVSImporter.importVisitingServiceDates = function (updateList) {
    serviceFinderData.jwt.getAuthToken();

    updateList.forEach(function (listItem) {
      serviceFinderData
        .collection("service-locations")
        .doc(dsServiceLocationData[listItem].id)
        .update(dsServiceLocationData[listItem])
        .then((response) => {
          sfVSImporter.report(
            `Visiting service date was successfully imported into Service Locations - <strong>${dsServiceLocationData[listItem].name}</strong>`,
            "Added",
            "success",
          );
          console.log(response);
        })
        .catch((error) => {
          sfVSImporter.report(
            `Failed to import visiting service date. Please check your permission and clear cache on your browser.`,
            "Other errors",
            "error",
          );
        });
    });
  };

  /**
   * Build out and display report for import
   *
   * @memberof module:serviceImporter
   */
  sfVSImporter.report = function (output, outcome, type) {
    var $importLogAdded = $("#sf-importer-tab--added");
    var $importLogNotFound = $("#sf-importer-tab--not-found");
    var $importLogAlreadyExists = $("#sf-importer-tab--already-exists");
    var $importLogOtherErrors = $("#sf-importer-tab--other-errors");
    var counter = ".sf-importer-tab--counter";

    if (outcome === "Added") {
      $importLogAdded.append(`<p class="text-${type}">${output}</p>`);
      $("#sf-importer-tab-heading--added")
        .find(counter)
        .html(
          parseInt(
            $("#sf-importer-tab-heading--added").find(counter).html(),
            10,
          ) + 1,
        );
    }

    if (outcome === "Not found") {
      $importLogNotFound.append(`<p class="text-${type}">${output}</p>`);
      $("#sf-importer-tab-heading--not-found")
        .find(counter)
        .html(
          parseInt(
            $("#sf-importer-tab-heading--not-found").find(counter).html(),
            10,
          ) + 1,
        );
    }

    if (outcome === "Already exists") {
      $importLogAlreadyExists.append(`<p class="text-${type}">${output}</p>`);
      $("#sf-importer-tab-heading--already-exists")
        .find(counter)
        .html(
          parseInt(
            $("#sf-importer-tab-heading--already-exists").find(counter).html(),
            10,
          ) + 1,
        );
    }

    if (outcome === "Other errors") {
      $importLogOtherErrors.append(`<p class="text-${type}">${output}</p>`);
      $("#sf-importer-tab-heading--other-errors")
        .find(counter)
        .html(
          parseInt(
            $("#sf-importer-tab-heading--other-errors").find(counter).html(),
            10,
          ) + 1,
        );
    }
  };

  // Assign
  QLD.sfVSImporter = sfVSImporter;

  // Init Admin Form
  $(document).ready(function () {
    if ($(".qld__sf_admin_vs_importer").length > 0) {
      QLD.sfVSImporter.init();
    }
  });
})();
